import { setTrackDesignChangesAction as setTrackDesignChangesOperation } from 'editor/src/store/editor/slice';

export default setTrackDesignChangesOperation;
